// Profile → חשבון → "התחברות לחשבון" (Option B, 2026-10-21; rendered only with GOOGLE_SIGNIN_ENABLED).
// A Google account without a password can ask for Firebase's existing password-setup (reset) email — always to its
// own verified account email (shown read-only, never typed here). Google + password: says both methods work.
// Email / password accounts: nothing is shown (they already have a password and the login screen's reset).
import React, { useState } from 'react';
import { getCurrentUser, sendPasswordSetupEmail } from '../../firebase';
import { passwordSetupStatus } from '../../utils/passwordSetup';
import { CARD, HELPER } from './ProfileParts';

const ERRORS = {
  rate_limited: 'נשלחו יותר מדי בקשות. נסה שוב מאוחר יותר.',
  failed: 'לא הצלחנו לשלוח את הקישור. נסה שוב.',
};

const Email = ({ value }) => <bdi dir="ltr" className="font-semibold text-text">{value}</bdi>;

export default function PasswordSetupSection() {
  const [status] = useState(() => passwordSetupStatus(getCurrentUser()));
  const [phase, setPhase] = useState('idle');          // idle | sending | sent | error
  const [error, setError] = useState('');

  if (status.reason === 'signed_out' || status.reason === 'not_google') return null;

  const send = async () => {
    if (phase === 'sending' || phase === 'sent') return;
    setPhase('sending');
    setError('');
    const result = await sendPasswordSetupEmail();
    if (result.success) { setPhase('sent'); return; }
    setError(ERRORS[result.reason] || ERRORS.failed);
    setPhase('error');
  };

  return (
    <div className={CARD} data-testid="pf-password-setup">
      <h3 className="text-[16px] font-bold text-text mb-1">התחברות לחשבון</h3>

      {status.reason === 'has_password' && (
        <p className={HELPER} data-testid="pf-password-both">אפשר להתחבר עם Google או עם האימייל והסיסמה שלך.</p>
      )}

      {status.reason === 'email_unverified' && (
        <p className={HELPER} data-testid="pf-password-unverified">
          כרגע אתה מתחבר עם Google. כדי להגדיר סיסמה, האימייל של החשבון צריך להיות מאומת. לעזרה: <Email value="support@ritmoiq.com" />
        </p>
      )}

      {status.eligible && (
        <div className="space-y-3">
          <p className={HELPER}>
            כרגע אתה מתחבר עם Google. אפשר להמשיך כך, או להגדיר סיסמה ולהתחבר גם עם אימייל וסיסמה.
          </p>
          <p className={HELPER} data-testid="pf-password-target">
            הקישור להגדרת הסיסמה יישלח לאימייל של החשבון: <Email value={status.email} />
          </p>
          {phase === 'sent' ? (
            <p role="status" className="text-[13px] text-text-body leading-snug" data-testid="pf-password-sent">
              שלחנו קישור לכתובת <Email value={status.email} />. פתח את המייל ובחר סיסמה. אחרי זה תוכל להתחבר עם Google או
              עם האימייל והסיסמה. לא קיבלת? בדוק גם בתיקיית הספאם.
            </p>
          ) : (
            <button type="button" onClick={send} disabled={phase === 'sending'}
                    className="w-full h-12 rounded-control border border-border text-text font-semibold text-[15px] disabled:opacity-50">
              {phase === 'sending' ? 'שולח...' : 'שליחת קישור להגדרת סיסמה'}
            </button>
          )}
          {phase === 'error' && (
            <p role="alert" className="text-quality text-[13px]" data-testid="pf-password-error">{error}</p>
          )}
        </div>
      )}
    </div>
  );
}
